import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const ClientCardHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  min-width: 240px;
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: ${Colors.primaryAccent};
  }

  &.selected {
    border-color: ${Colors.primaryAccent};
    background: ${Colors.extraLightPrimary};
    box-shadow: 0 0 0 2px ${Colors.primary}33;
  }

  &.is-skeleton {
    cursor: default;
    pointer-events: none;
  }
  &.is-skeleton:hover {
    border-color: ${Colors.border};
  }

  .client-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .client-name {
      font-weight: 500;
      color: ${Colors.textStrong};
    }
  }

  .client-logo {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    overflow: hidden;
    background: ${Colors.background};
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .client-logo-icon {
      font-size: 22px;
      color: ${Colors.textMuted};
    }
  }
`

export default ClientCardHolder
